import { ApiCommunications, NullPromise } from '../../webmodule-common/interop/webmodule-interop';
import type {
  FabricationJobSummaryViewResultPaginated,
  InputAddQuoteItemToFabricationJob,
  InputCleanupQuoteFabricationData,
  InputCreateFabricationJob,
  InputCreateQuoteItemFabrications,
  InputDeleteFabricationJob,
  InputRemoveQuoteItemFromFabricationJob,
  InputUpdateFabricationJob,
  InputUpdateFabricationJobItemUnitOverrides,
  RequestGetFabricationJob,
  RequestGetFabricationJobSummary,
  RequestGetFabricationJobTotalsByState,
  RequestGetQuoteItemFabricationStatuses,
  ResultCleanupQuoteFabricationData,
  ResultCreateFabricationJob,
  ResultCreateQuoteItemFabrications,
  ResultGetFabricationJob,
  ResultGetFabricationJobTotalsByState,
  ResultGetQuoteItemFabricationStatuses,
  ResultUpdateFabricationJob
} from './dealer-api-interface-all';
import type { FabricationJobApi } from './fabrication-job-api';

export class FabricationJobApiImplementation implements FabricationJobApi {
  api: ApiCommunications;

  constructor(api: ApiCommunications) {
    this.api = api;
  }

  async getFabricationJob(request: RequestGetFabricationJob): NullPromise<ResultGetFabricationJob> {
    return await this.api.post<ResultGetFabricationJob>('api/FabricationJob/GetFabricationJob', request);
  }

  async getFabricationJobSummary(
    request: RequestGetFabricationJobSummary
  ): NullPromise<FabricationJobSummaryViewResultPaginated> {
    return await this.api.post<FabricationJobSummaryViewResultPaginated>(
      'api/FabricationJob/GetFabricationJobSummary',
      request
    );
  }

  async getFabricationJobTotalsByState(
    request: RequestGetFabricationJobTotalsByState
  ): NullPromise<ResultGetFabricationJobTotalsByState> {
    return await this.api.post<ResultGetFabricationJobTotalsByState>(
      'api/FabricationJob/GetFabricationJobTotalsByState',
      request
    );
  }

  async getQuoteItemFabricationStatuses(
    request: RequestGetQuoteItemFabricationStatuses
  ): NullPromise<ResultGetQuoteItemFabricationStatuses> {
    return await this.api.post<ResultGetQuoteItemFabricationStatuses>(
      'api/FabricationJob/GetQuoteItemFabricationStatuses',
      request
    );
  }

  async createFabricationJob(input: InputCreateFabricationJob): NullPromise<ResultCreateFabricationJob> {
    return await this.api.post<ResultCreateFabricationJob>('api/FabricationJob/CreateFabricationJob', input);
  }

  async updateFabricationJob(input: InputUpdateFabricationJob): NullPromise<ResultUpdateFabricationJob> {
    return await this.api.post<ResultUpdateFabricationJob>('api/FabricationJob/UpdateFabricationJob', input);
  }

  async deleteFabricationJob(input: InputDeleteFabricationJob): NullPromise<ResultUpdateFabricationJob> {
    return await this.api.post<ResultUpdateFabricationJob>('api/FabricationJob/DeleteFabricationJob', input);
  }

  async addQuoteItemToFabricationJob(
    input: InputAddQuoteItemToFabricationJob
  ): NullPromise<ResultUpdateFabricationJob> {
    return await this.api.post<ResultUpdateFabricationJob>('api/FabricationJob/AddQuoteItemToFabricationJob', input);
  }

  async removeQuoteItemFromFabricationJob(
    input: InputRemoveQuoteItemFromFabricationJob
  ): NullPromise<ResultUpdateFabricationJob> {
    return await this.api.post<ResultUpdateFabricationJob>(
      'api/FabricationJob/RemoveQuoteItemFromFabricationJob',
      input
    );
  }

  async updateFabricationJobItemUnitOverrides(
    input: InputUpdateFabricationJobItemUnitOverrides
  ): NullPromise<ResultUpdateFabricationJob> {
    return await this.api.post<ResultUpdateFabricationJob>(
      'api/FabricationJob/UpdateFabricationJobItemUnitOverrides',
      input
    );
  }

  async createQuoteItemFabrications(
    input: InputCreateQuoteItemFabrications
  ): NullPromise<ResultCreateQuoteItemFabrications> {
    return await this.api.post<ResultCreateQuoteItemFabrications>(
      'api/FabricationJob/CreateQuoteItemFabrications',
      input
    );
  }

  async cleanupQuoteFabricationData(
    input: InputCleanupQuoteFabricationData
  ): NullPromise<ResultCleanupQuoteFabricationData> {
    return await this.api.post<ResultCleanupQuoteFabricationData>(
      'api/FabricationJob/CleanupQuoteFabricationData',
      input
    );
  }
}
